export function normalizeAddress(address) {
    // let lowercaseInput = address.toLowerCase();
    // let formattedAddress = lowercaseInput.replace(/(^|\s)\S/gu, function (match) {
    //     return match.toUpperCase();
    // });
    // formattedAddress = formattedAddress.replace(/\s\(/gu, ', (').replace(/\(/gu, ' (');

    // return formattedAddress;

    const parts = address.split(" ");

    // Capitalize the first letter of each word in the address
    const capitalizedParts = parts.map((part) => {
        if (part.charAt(0) === "(") {
            return (
                "(" +
                part.charAt(0 + 1).toUpperCase() +
                part.slice(1 + 1).toLowerCase()
            );
        } else {
            return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
        }
    });

    // Join the parts back together with spaces
    const convertedAddress = capitalizedParts.join(" ");

    return convertedAddress;
}

export function parsePropertyType(propertyType) {
    console.log("converted to");
    if (propertyType === 0) return 0;
    if (
        propertyType === 3 ||
        propertyType === 5 ||
        propertyType === 6 ||
        propertyType === 8
    ) {
        return 1;
    }
    if (
        propertyType === 1 ||
        propertyType === 2 ||
        propertyType === 4 ||
        propertyType === 7
    ) {
        return 2;
    }
}
